<template>
    <div id="contendor-principal-edicion">
         <div id="contenedor-encabezados-resultados" class="text-left">
            <h1>CREACIÓN DE RESULTADO </h1>
            <div id="contendor-edicion">
                <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
                    <div class="flex-grow-1"><button type="button" @click="regresarAResultados" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left" style="font-size:20px;"></i></button></div>
                    <div class="flex-grow-1" style="padding-left: 11em;"><h4>Asignación de resultado</h4></div>
                    <div class="flex-grow-1"></div>
                </div>
                <div id="contenedor-informacion" class="area col-12">
                    <!-- <div class="d-flex justify-content-between align-items-center">
                        <h3>Sigue los pasos para crear el resultado de la cédula</h3>
                        <button type="button" @click="regresarAResultados" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left"></i></button>
                    </div>
                    <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/> -->
                    <div class="d-flex">
                        <div id="informacion-cedula" class="col-3 pl-0">
                            <div class="contenedor-color-negro">
                                <h5>Información de cédula</h5>
                                <hr />
                                <div class="form-group">
                                    <h6>Folio de cédula</h6>
                                    <input disabled v-model="folioCedula" type="text" class="form-control"/>
                                </div>
                                <div class="form-group">
                                    <h6>Juzgado</h6>
                                    <input disabled v-model="juzgadoCedula" type="text" class="form-control"/>
                                </div>
                                <div class="form-group">
                                    <h6>Tipo de documento</h6>
                                    <input disabled v-model="tipoDeDocumetoCedula" type="text" class="form-control"/>
                                </div>
                                <div class="form-group">
                                    <h6>Número de documento</h6>
                                    <input disabled v-model="numeroDeDocumentoCedula" type="text" class="form-control"/>
                                </div>
                                <div class="form-group">
                                    <h6>Tipo de Cédula</h6>
                                    <input disabled v-model="tipoDeCedula" type="text" class="form-control"/>
                                </div>
                                <div style="margin-top: 3em;">
                                    <h6>Observaciones de abogados</h6>
                                    <hr />
                                    <div v-if="observacionesDeAbogado.length < 1" class="contenedor-anexos">
                                        <h6 class="text-center">Sin observaciones</h6>
                                    </div>
                                    <div id="contenedor-observaciones">
                                        <div v-for="(observacion,index) in observacionesDeAbogado" class="form-group" :key="index">
                                            <h6>[{{obtenerNombreCompleto(observacion)}}]</h6>
                                            <textarea disabled v-model="observacion.Observaciones" type="text" rows="3" class="form-control"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="informacion-resultado" class="col-9 pl-2 pr-0">
                            <div class="contenedor-color-negro">
                                <h5>Paso 1: Llene el formulario de resultado</h5>
                                <hr />
                                <div class="d-flex">
                                    <div class="w-50">
                                        <div class="form-group">
                                            <h6 for="estatus-resultado">Estatus</h6>
                                            <input id="estatus-resultado" disabled v-model="ESTATUS_RESULTADO" type="text" class="form-control"/>
                                        </div>
                                        <div class="form-group">
                                            <h6 for="indicar-como">Indicar resultado como : &nbsp;
                                                <i v-if="mostrarErroresPasoUno && this.campoRequeridoEsValido(tipoFinalizacionId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresPasoUno && !this.campoRequeridoEsValido(tipoFinalizacionId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                            <CCatalogoGenerico id="indicar-como" class="p-0 m-0" 
                                                v-on:valorParaElPadre="evtCambioTipoIndicarComo($event)" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'CTipoParaVPlantillasFiltro'" 
                                                :valorDefinido="tipoFinalizacionId"
                                                :textoOpcionesSingular="'modo de finalizar el resultado.'"
                                                :textoOpcionesPlural="'modos de finalizar el resultado.'"
                                                :elementosCatalogo="tiposDeFinalizacion"
                                                :key="'KCTDPF'"></CCatalogoGenerico>
                                        </div>
                                        <div v-if="esResultadoRealizada" class="form-group">
                                            <h6 for="tipo-resultado">Tipo de resultado</h6>
                                            <input id="tipo-resultado" disabled v-model="ESTATUS_RESULTADO" type="text" class="form-control"/>
                                        </div>
                                        <div v-if="esResultadoRazonada" class="form-group">
                                            <h6>Tipo de razonamiento&nbsp;
                                                <i v-if="mostrarErroresPasoUno && this.campoRequeridoEsValido(tipoDeRazonSeleccionada)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                                <i v-if="mostrarErroresPasoUno && !this.campoRequeridoEsValido(tipoDeRazonSeleccionada)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                            <C022TiposDeRazones class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoRazon" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'CTipoDeRazonVEDR'" 
                                                :parametros="{TipoRazonId: null, Nombre: null}"
                                                :valorDefinido="-1"
                                                :key="'KCTipoDeRazonVEDR' + contadorRenderCatalogos"></C022TiposDeRazones>
                                        </div>
                                    </div>
                                    <div class="ml-3 p-0 w-50">
                                        <h6>Observaciones</h6>
                                        <textarea v-model="observacionesResultado" rows="6" type="text" class="form-control"/>
                                    </div>
                                </div>
                            </div>
                            <div class="contenedor-color-negro mt-4">
                                <h5>Paso 2 [Opcional]: Suba el documento del resultado y los anexos necesarios.</h5>
                                <hr />
                                <CEleccionDePlantilla style="margin-bottom:2em;"
                                    :idComponente="'CEPEdicionResultado'"
                                    :ref="REF_CEP"
                                    :filtrosDePlantillas="filtrosDeplantillas"
                                    :eleccionPara="'Resultado'"
                                    :archivoSubirExtensionesValidas="'.DOC, .DOCX, .PDF, .JPEG, .PNG, .JPG'"
                                    :valorDefinidoCatalogo="tipoPlantillaId"
                                    :contadorRender="contRenderEP"
                                    :conSubidorDeArchivo="true"
                                    :archivoParaSubir="archivoDeResultadoSeleccionado"
                                    v-on:obtArchivoASubir="archivoDeResultadoSeleccionado = $event"></CEleccionDePlantilla>
                                <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                                <div class="form-group">
                                    <h6 for="subidor-anexo">Anexo de resultado (opcional).&nbsp;
                                        <i v-if="mostrarErroresPasoDos && this.archivoDeAnexoEsValido(archivoAnexoSeleccionado)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="mostrarErroresPasoDos && !this.archivoDeAnexoEsValido(archivoAnexoSeleccionado)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <div id="subidor-anexo" class="d-flex align-items-center">
                                        <input type="file" id="input-anexo-resultado" :class="[mostrarErroresPasoDos && !this.archivoDeAnexoEsValido(archivoAnexoSeleccionado) ? 'form-control border border-danger' : 'form-control']" v-on:change="evtAgregarAnexoResultado($event)" accept=".PDF, .PNG, .JPG, .JPEG" />
                                        <button @click="evtAgregarAnexoEnLista" type="button" class="btn btn-primary ml-2"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button>
                                    </div>
                                </div>
                                <div class="form-group mt-4">
                                    <h6 for="tabla-anexos">Anexos del resultado</h6>
                                    <div class="contenedor-anexos" id="tabla-anexos">
                                        <div v-for="(anexo,index) in anexosDeResultado" :class="[(index == 0) ? 'contenido-descarga-plantilla' : 'contenido-descarga-plantilla mt-2']" :key="index">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <i :class="[anexo.iconoPdf ? 'fas fa-file-alt mr-2' : 'fas fa-image mr-2']" style="font-size: 23px;"></i>
                                                <span style="color: #000000; font-weight: bold;">{{anexo.nombre}}</span>
                                            </div>
                                            <div>
                                                <button :id="'btn-eliminar-anexo-' + anexo.referencia" @click="evtElimnarAnexoDeLista($event)" type="button" class="btn btn-primary"><i :id="'i-eliminar-anexo-' + anexo.referencia" class="fas fa-minus-square"></i>&nbsp;&nbsp;Eliminar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end mt-3">
                                <button @click="evtGuardarResultado" type="button" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar Resultado</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import router from '@/router/index'
import catalogos from '@/../static/js/catalogos'

export default {
    components: {
        C015TiposDeResultado: catalogos.SINOJ.C015TiposDeResultado,
        C022TiposDeRazones: catalogos.SINOJ.C022TiposDeRazones,
        C011TiposEstatus: catalogos.SINOJ.C011TiposEstatus,
        CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico,
        CEleccionDePlantilla: sistemas.SINOJ.CEleccionDePlantilla,
    },
    data() {
        return {
            enumeraciones,
            folioCedula: null,
            juzgadoCedula: null,
            tipoDeDocumetoCedula: null,
            numeroDeDocumentoCedula: null,
            tipoDeCedula: null,
            observacionesDeAbogado: [],
            anexosDeResultado: [],
            observacionesResultado: null,
            archivoAnexoSeleccionado: null,
            archivoDeResultadoSeleccionado: null,
            tipoDeRazonSeleccionada: null,
            contadorRenderCatalogos: 0,
            cedulaBD: null,
            mostrarErroresPasoDos: false,
            mostrarErroresPasoUno: false,
            contadorDeAnexos: 0,
            filtrosPreviosVistaResultado: null,
            filtrosDeplantillas: {
                TipoPlantillaId: null,
                Nombre: null,
                TipoCedulaId: null,
                TipoResultadoId: null,
                TipoRazonId: null,
                FechaInicial: null,
                FechaFinal: null,
                PlantillasDe: enumeraciones.sinoj.requierenPlantilla.resultado.llave,
                ConInactivos: false,
                EsPrueba: false
            },
            tipoPlantillaId: -1,
            contRenderEP: 0,
            REF_CEP: 'RefEleccionPlantillaVEDR',
            ESTATUS_RESULTADO: 'REALIZADA',
            esResultadoRealizada: false,
            esResultadoRazonada: false,
            tiposDeFinalizacion: [],
            tipoFinalizacionId: -1
        }
    },
    methods: {
        evtCambioTipoIndicarComo: function(evento) { 
            const ID_SELECCION = parseInt(evento.target.value);
            this.tipoFinalizacionId = ID_SELECCION;
            this.tipoDeRazonSeleccionada = null;
            this.limpiarCamposPasoDosDocumento();
            this.limpiarFiltrosPlantillas();
            this.contRenderEP ++;
            switch(ID_SELECCION) {
                case enumeraciones.sinoj.tiposResultado.Realizada:
                    this.filtrosDeplantillas.TipoResultadoId = ID_SELECCION;
                    this.contRenderEP ++;
                    this.esResultadoRealizada = true;
                    this.esResultadoRazonada = false;
                    this.contadorRenderCatalogos ++;
                    break;
                case enumeraciones.sinoj.tiposResultado.Razonada:
                    this.esResultadoRazonada = true;
                    this.esResultadoRealizada = false;
                    this.contadorRenderCatalogos ++;
                    break; 
                default:
                    this.esResultadoRazonada = false;
                    this.esResultadoRealizada = false;
                    this.contadorRenderCatalogos ++;
                    this.limpiarFiltrosPlantillas();
                    this.contRenderEP ++;
                    break;
            }
        },
        crearPeticionDeResultado: function() {
            const REFERENCIA_ARCHIVO_RESULTADO = 'ArchivoResultado';
            let peticion = new FormData();
            let resultadoObj = {};
            resultadoObj.ResultadoId = -1;
            resultadoObj.ObservacionesResultado = this.observacionesResultado;
            resultadoObj.FechaResultado = moment();
            resultadoObj.ArchivoResultado_Ruta = null;
            if(this.campoRequeridoEsValido(this.archivoDeResultadoSeleccionado)) {
                resultadoObj.ArchivoResultado_Ruta = REFERENCIA_ARCHIVO_RESULTADO;
                peticion.append(REFERENCIA_ARCHIVO_RESULTADO, this.archivoDeResultadoSeleccionado);
            }
            let estatusCedulaObj = {
                TipoEstatusId: enumeraciones.sinoj.tiposEstatus.finalizado
            };
            resultadoObj.Cedula = {
                CedulaId: this.cedulaBD.CedulaId,
                Estatus: estatusCedulaObj
            };
            resultadoObj.TipoResultado = {
                TipoResultadoId: (this.tipoDeRazonSeleccionada != null) ? enumeraciones.sinoj.tiposResultado.Razonada : enumeraciones.sinoj.tiposResultado.Realizada 
            };
            resultadoObj.TipoRazon = {
                TipoRazonId: (this.tipoDeRazonSeleccionada != null) ? this.tipoDeRazonSeleccionada.TipoRazonId : -1
            };
            resultadoObj.Usuario = null;
            let anexosObj = [];
            if(this.anexosDeResultado != null && this.anexosDeResultado.length > 0) {
                this.anexosDeResultado.forEach(a => {
                    peticion.append(a.referencia,a.archivo);
                    let anexoObj = {};
                    anexoObj.AnexoId = -1;
                    anexoObj.AnexoRuta = a.referencia;
                    anexoObj.Resultado = null;
                    anexosObj.push(anexoObj);
                });
            }
            resultadoObj.Anexos = anexosObj;
            peticion.append('Resultado',JSON.stringify(resultadoObj));
            peticion.append('EsPrueba',false);
            peticion.append('ReferenciaArchivo',(this.campoRequeridoEsValido(this.archivoDeResultadoSeleccionado)) ? REFERENCIA_ARCHIVO_RESULTADO : 'SIN ARCHIVO');
            /* console.log('VALORES FORMDATA');
            for (var pair of peticion.entries()) {
                console.log(pair[0]+ ', ',pair[1]); 
            } */
            return peticion;
        },
        evtGuardarResultado: function() {
            if(this.validacionCamposObligatorios()) {
                this.mostrarErroresPasoUno = false;
                let peticionAPi = this.crearPeticionDeResultado();
                this.guardarResultadoBD(peticionAPi);
            }
            else {
                this.mostrarErroresPasoUno = true;
            }
        },
        guardarResultadoBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_GUARDAR = api.SINOJ.sistema.notificaciones.resultado.GuardarResultadoDeCedula;
            let urlApi = SERVIDOR + METODO_API_GUARDAR;
            let peticionArchivos = true;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            this.limpiarCamposPasoUno();
                            this.limpiarCamposPasoDosDocumento();
                            this.limpiarCamposPasoDosAnexos();
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                            this.regresarAResultados();
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        validacionCamposObligatorios: function() { 
            let camposValidos = true;
            let camposObligatorios = [ {mensajeError: 'debes indicar el modo de finalizar el resultado', input: this.tipoFinalizacionId} ];
            if(this.tipoFinalizacionId == enumeraciones.sinoj.tiposResultado.Razonada) {
                camposObligatorios.push({mensajeError: 'debes seleccionar un tipo de razonamiento valido', input: this.tipoDeRazonSeleccionada});
            }
            
            for(let i=0; i < camposObligatorios.length; i++) {
                if(!this.campoRequeridoEsValido(camposObligatorios[i].input)) {
                    camposValidos = false;
                    this.mostrarErroresPasoUno = true;
                    comun.mensajeDeAlerta(`Se detectaron campos incorrectos,<br>${camposObligatorios[i].mensajeError}`);
                    break;
                }
            }
            this.mostrarErroresPasoUno = false;
            return camposValidos;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        evtElimnarAnexoDeLista: function(evento) {
            const ANEXO_ID = evento.target.getAttribute('id');
            const ID_COMPLETO = ANEXO_ID.split('-');
            const ID = parseInt(ID_COMPLETO[ID_COMPLETO.length - 1]);
            this.anexosDeResultado = this.anexosDeResultado.filter(a => a.referencia != ID);
            if(this.anexosDeResultado.length < 1)
                this.contadorDeAnexos = 0;
            comun.mensajeDeAlerta('El anexo se removio correctamente de la lista');
        },
        evtAgregarAnexoEnLista: function() {
            if(this.archivoDeAnexoEsValido(this.archivoAnexoSeleccionado)) {
                this.mostrarErroresPasoDos = false;
                const ANEXO_AGREGADO = this.crearObjAnexo();
                this.anexosDeResultado.push(ANEXO_AGREGADO);
                $("#input-anexo-resultado").val('');
                this.archivoAnexoSeleccionado = null;
                this.mostrarErroresPasoDos = false;
                comun.mensajeDeAlerta('El anexo se agrego correctamente a la lista');
            }
            else {
                this.mostrarErroresPasoDos = true;
                comun.mensajeDeAlerta('Para poder agregar un anexo debes seleccionar un archivo(.PDF, .PNG, .JPG, .JPEG).');
            }
        },
        limpiarCamposPasoDosAnexos: function() {
            $("#input-anexo-resultado").val('');
            this.anexosDeResultado = [];
            this.contadorDeAnexos = 0;
            this.mostrarErroresPasoDos = false;
        },
        limpiarCamposPasoUno: function() {
            this.contadorRenderCatalogos ++;
            this.ObservacionesResultado = null;
            this.mostrarErroresPasoUno = false;
            this.tipoDeRazonSeleccionada = null;
            this.archivoAnexoSeleccionado = null;
        },
        limpiarCamposPasoDosDocumento: function() {
            $("#input-archivoDeResultado").val('');
            this.anexosDeResultado = [];
            this.contadorDeAnexos = 0;
            this.mostrarErroresPasoDos = false;
            this.archivoDeResultadoSeleccionado = null;
            this.$refs[this.REF_CEP].limpiarInputArchivo();
        },
        crearObjAnexo: function() {
            let anexoObj = {};
            anexoObj.referencia = this.contadorDeAnexos += 1;
            anexoObj.nombre = this.archivoAnexoSeleccionado.name;
            anexoObj.archivo = this.archivoAnexoSeleccionado;
            anexoObj.iconoPdf = (this.archivoAnexoSeleccionado.type == 'application/pdf') ? true : false;
            return anexoObj;
        },
        archivoDeAnexoEsValido: function(archivo) {
            let esValido = false;
            if(archivo != null)
                esValido = true;
            return esValido
        },
        evtAgregarAnexoResultado: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    this.archivoAnexoSeleccionado = evento.target.files[0];
                }
                else {
                    this.archivoAnexoSeleccionado = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        limpiarFiltrosPlantillas: function() {
            this.filtrosDeplantillas =  {
                TipoPlantillaId: null,
                Nombre: null,
                TipoCedulaId: null,
                TipoResultadoId: null,
                TipoRazonId: null,
                FechaInicial: null,
                FechaFinal: null,
                PlantillasDe: null,
                ConInactivos: false,
                EsPrueba: false
            }
        },
        evtCambioTipoRazon: function(evento,tipoRazonObj) {
            this.tipoDeRazonSeleccionada = tipoRazonObj;
            this.limpiarCamposPasoDosDocumento();
            if(this.tipoDeRazonSeleccionada != null) {
                this.limpiarFiltrosPlantillas();
                this.filtrosDeplantillas.TipoRazonId = this.tipoDeRazonSeleccionada.TipoRazonId;
                this.contRenderEP ++;
            }
            else {
                this.limpiarFiltrosPlantillas();
                this.contRenderEP ++;
            }
        },
        regresarAResultados: function() {
            let tieneFiltroPrevios = Object.values(this.filtrosPreviosVistaResultado).some(f => {
                if(typeof f === 'string' || f instanceof String) {
                    // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                    if (f != null && f != undefined && f != '') {
                        return true;
                    }
                }
                else if (typeof f === 'number' || f instanceof Number) {
                    // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                    if (f != null && f != undefined && f > 0) {
                        return true;
                    }
                }
            });
            this.filtrosPreviosVistaResultado.cargarConFiltros = tieneFiltroPrevios;
            router.push({ name: "Resultados", params: { filtrosParaCargar: this.filtrosPreviosVistaResultado } });
        },
        obtenerIdDeAnexo: function(anexoSeleccionado) {
            const anexo = anexoSeleccionado.split('-');
            const posicionDeId = (anexo.length - 1);
            const idAnexo = anexo[posicionDeId];
            return idAnexo;
        },
        cargarCedulaBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.catalogos.C001Cedula;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = false;
            let peticionAPI = {
                CedulaId: this.folioCedula,
                ConAsignaciones: false,
                ConSalidas: false,
                ConObservacionesDeAbogados: true,
                ConAcuerdos: true,
                EsPrueba: false
            }
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            this.cedulaBD = respuesta.data.Cedula;
                            //console.log('cedulaBD::',this.cedulaBD)
                            if(this.cedulaBD != null)
                                this.llenarCamposInformacionBasica(this.cedulaBD);
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
      },
      llenarCamposInformacionBasica: function(cedula) {
          if(cedula.Expediente != null) {
            this.tipoDeDocumetoCedula = (cedula.Expediente.TipoDocumento != null) ? cedula.Expediente.TipoDocumento.Nombre : null;
            this.numeroDeDocumentoCedula = cedula.Expediente.NumeroDeDocumento;
          }
          if(cedula.Expediente != null)
            this.juzgadoCedula = (cedula.Expediente.Juzgado != null) ? cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
          
          this.tipoDeCedula = cedula.TipoCedula.Nombre;
          if(cedula.ObservacionesDeAbogados != null && cedula.ObservacionesDeAbogados.length > 0)
            this.observacionesDeAbogado = cedula.ObservacionesDeAbogados;
      },
      obtenerNombreCompleto: function(observacion) {
          const USUARIO_OBSERVACION = observacion.Usuario;
          const DATOS_NOMBRE = [USUARIO_OBSERVACION.Nombre, USUARIO_OBSERVACION.ApellidoPaterno, USUARIO_OBSERVACION.ApellidoMaterno];
          return DATOS_NOMBRE.join(' ');
      }
    },
    created() {
        const PARAMETROS_VISTA = router.history.current.params;
        if(PARAMETROS_VISTA.filtrosPrevios == null || PARAMETROS_VISTA.filtrosPrevios == undefined) {
            router.push({ name: "Resultados"});
        }
        else {
            const TIPOS_FINALIZAR = enumeraciones.sinoj.tiposResultado;
            this.tiposDeFinalizacion = [{llave: TIPOS_FINALIZAR.Razonada, valor: 'Cedula razonada'}, {llave: TIPOS_FINALIZAR.Realizada, valor: 'Cedula realizada'}];
            this.folioCedula = router.history.current.params.folio;
            this.filtrosPreviosVistaResultado = PARAMETROS_VISTA.filtrosPrevios;
            this.cargarCedulaBD();
        }
    }
}
</script>
<style scoped>
    .contenedor-color-negro {
        padding: 1.5em;
        background-color: #2c2d31;
        box-shadow: 0px 6px 20px 8px #161616;
    }

    textarea {
        padding: 0.6em !important;
    }

    .anexos {
        padding: 0.5em;
        background-color: #504f54;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .btn-sm {
        width: 25px;
        height: 25px;
        padding: 0;
        cursor: pointer;
    }

    .btn-anexo {
        width: 6rem;
        height: 25px;
        padding: 0;
        cursor: pointer;
    }

    .btn-primary:active:hover,
    .btn-primary:hover,
    .btn-primary:focus {
        border-color: black;
        background-color: black;
        /* utilizar en caso de querer eliminar los bordes */
        /* box-shadow: none!important;
        outline: 0; */
    }

    .contenedor-editorDeTexto {
        border: 3px solid #5c5959; 
        box-shadow: 0px 6px 20px 8px #0e0d0d;
    }

    .contenedor-anexos {
        background-color: #242425;
        max-height: 16em;
        overflow-y: auto;
        padding: 8px;
        border-radius: 4px;
    }

    #contenedor-observaciones {
        margin-top: 1em;
        padding-right: 4px;
        max-height: 16em;
        overflow-y: auto;
    }

    .contenido-descarga-plantilla {
        padding: 5px 9px 5px 9px;
        border-radius: 4px;
        background-color: #817c7c;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .contenedor-plantilla {
        padding: 5px 9px 5px 9px;
        border-radius: 4px;
        background-color: #817c7c;
    }

    #encabezado-contenedor-contenido {
        background-color: rgb(44, 43, 43);
        padding: 10px;
    }

    #encabezado-contenedor-contenido .btn {
        background-color: black;
        padding-left: 15px;
        padding-right: 15px;
    }

</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Notificaciones/Resultados/Edicion/CEdicionDeResultado.vue